export default Object.freeze({
  LEAD_REVIEWER: 'LEAD_REVIEWER',
  REVIEWER: 'REVIEWER',
  VIEWER: 'VIEWER',
});
